import React, { FC, useMemo } from "react";
import { useSDMCustomerContext } from "@ldp/sdm-contexts";
import {
  ProvinceSelectorWrapper,
  SelectBox,
} from "@ldp-web/component-library/ui/molecules/form/selectbox";

/** props for province list */
export type ProvinceOptions = {
  /** code for the key */
  code: string;
  /** Name of the Element */
  name: string;
  /** selected boolean */
  selected: boolean;
};
/** Province selector types */
export interface IProvinceSelectorComponentProps {
  /** text for the droddown */
  displayText1: string;
  /** province list object */
  provinceList: ProvinceOptions[]; // TODO: update prop type based on BFF update
}

/** Shows province list dropdown to select province */
export const ProvinceSelectorComponent: FC<IProvinceSelectorComponentProps> = ({
  displayText1,
  provinceList,
}) => {
  const { provinceId, setProvinceId } = useSDMCustomerContext();
  /** adds a new key called 'selected' to the object */
  const updatedOptions = useMemo(() => {
    return provinceList.map((province) => {
      return {
        ...province,
        selected: province.code === provinceId,
      };
    }) as ProvinceOptions[];
  }, [provinceList, provinceId]);

  /** updates selected province code */
  const updateSelectedProvince = (val: string) => {
    const selectedProvinceCode = provinceList.find(
      (province) => province.name === val
    )?.code;
    if (selectedProvinceCode) {
      setProvinceId(selectedProvinceCode);
    }
  };
  return (
    <ProvinceSelectorWrapper>
      <SelectBox
        key={provinceId}
        label={displayText1}
        labelId="location"
        menuName="menu-button-:r1:"
        options={updatedOptions}
        onSelected={updateSelectedProvince}
      />
    </ProvinceSelectorWrapper>
  );
};

export default ProvinceSelectorComponent;
